/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Video_AvailableInputs */

const en_no_video_available = /** @type {(inputs: No_Video_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No video available`)
};

const es_no_video_available = /** @type {(inputs: No_Video_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay video disponible`)
};

const fr_no_video_available = /** @type {(inputs: No_Video_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune vidéo disponible`)
};

const de_no_video_available = /** @type {(inputs: No_Video_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Video verfügbar`)
};

const ja_no_video_available = /** @type {(inputs: No_Video_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用可能なビデオはありません`)
};

const zh_no_video_available = /** @type {(inputs: No_Video_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有可用视频`)
};

const ar_no_video_available = /** @type {(inputs: No_Video_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يوجد فيديو متاح`)
};

const id_no_video_available = /** @type {(inputs: No_Video_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada video tersedia`)
};

const it_no_video_available = /** @type {(inputs: No_Video_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun video disponibile`)
};

const ru_no_video_available = /** @type {(inputs: No_Video_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видео недоступно`)
};

const pt_no_video_available = /** @type {(inputs: No_Video_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum vídeo disponível`)
};

const ko_no_video_available = /** @type {(inputs: No_Video_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사용 가능한 비디오 없음`)
};

/**
* | output |
* | --- |
* | "No video available" |
*
* @param {No_Video_AvailableInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_video_available = /** @type {((inputs?: No_Video_AvailableInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Video_AvailableInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_video_available(inputs)
	if (locale === "es") return es_no_video_available(inputs)
	if (locale === "fr") return fr_no_video_available(inputs)
	if (locale === "de") return de_no_video_available(inputs)
	if (locale === "ja") return ja_no_video_available(inputs)
	if (locale === "zh") return zh_no_video_available(inputs)
	if (locale === "ar") return ar_no_video_available(inputs)
	if (locale === "id") return id_no_video_available(inputs)
	if (locale === "it") return it_no_video_available(inputs)
	if (locale === "ru") return ru_no_video_available(inputs)
	if (locale === "pt") return pt_no_video_available(inputs)
	return ko_no_video_available(inputs)
});